"use strict";
/**
 * Template: Gift card
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Gift Card template.
 *
 */

var config = {
  qrCode: '#QrCode',
  printButton: '#PrintGiftCard',
  giftCardCode: '.giftcard__code'
}; // new QRCode($qrCode[0], {
//   text: $qrCode.attr('data-identifier'),
//   width: 120,
//   height: 120,
// });

var printBtn = document.querySelector(config.printButton);

if (printBtn) {
  printBtn.addEventListener('click', function (element) {
    element.preventDefault();
    window.print();
  });
} // Auto-select gift card code on click, based on ID passed to the function


var giftCardCodeEl = document.querySelector(config.giftCardCode);

if (giftCardCodeEl) {
  giftCardCodeEl.addEventListener('click', function () {
    return selectText({
      data: {
        element: 'GiftCardDigits'
      }
    });
  });
}

function selectText(evt) {
  var text = document.getElementById(evt.data.element);
  var range = '';

  if (document.body.createTextRange) {
    range = document.body.createTextRange();
    range.moveToElementText(text);
    range.select();
  } else if (window.getSelection) {
    var selection = window.getSelection();
    range = document.createRange();
    range.selectNodeContents(text);
    selection.removeAllRanges();
    selection.addRange(range);
  }
}